import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AccommodationAvailabilitySetComponent } from '../../accommodation-availability-set/accommodation-availability-set.component';
import { AccommodationService } from '../../accommodation.service';

@Component({
	selector: 'app-accommodation-list-product',
	templateUrl: './accommodation-list-product.component.html',
	styleUrls: ['./accommodation-list-product.component.css'],
})
export class AccommodationListProductComponent {
	@Input() accommodationAvailabilitySetComponent = null;
	@Input() product = null;
	@Input() show;
	showAdditionalData = false;

	constructor(
		private readonly dialog: MatDialog,
		private readonly service: AccommodationService,
	) {}

	availabilitySet() {
		this.dialog
			.open(AccommodationAvailabilitySetComponent, {
				data: this.product,
				disableClose: true,
			})
			.afterClosed()
			.subscribe(() => {
				this.service.loadAvailabilities();
			});
	}
}
